import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import SideBar from './SideBar';
import TopNav from './TopNav';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS

const Reports = () => {
    return (
        <div className="d-flex">
            <SideBar />
            <div className="flex-grow-1 d-flex justify-content-end p-3" style={{ maxWidth: '80%', marginLeft: 'auto' }}>
                <div style={{ width: '100%', textAlign: 'right' }}>
                    <TopNav />
                    <h1 className="mb-4 text-center">Reports</h1>
                    <div className="row justify-content-end">
                        <div className="col-md-4">
                            <div className="card text-center mb-4">
                                <div className="card-body">
                                    <h5 className="card-title">Daily Sales Report</h5>
                                    <p className="card-text">View today's sales report.</p>
                                    <Link to="/DailySalesReports" className="btn btn-primary">View Report</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card text-center mb-4">
                                <div className="card-body">
                                    <h5 className="card-title">Weekly Sales Report</h5>
                                    <p className="card-text">View this week's sales report.</p>
                                    <Link to="/WeeklySalesReports" className="btn btn-primary">View Report</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card text-center mb-4">
                                <div className="card-body">
                                    <h5 className="card-title">Inventory Movement Report</h5>
                                    <p className="card-text">Track inventory movements.</p>
                                    <Link to="/InventoryMovementReports" className="btn btn-primary">View Report</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reports;